/* eslint-disable jsdoc/check-tag-names */
import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class Page extends CloudObject {}

// Hardcoded tags
register('018c354ad94307781093', Page);
Page.mainCategoryProp = defineProperty('018c354b169304bf5ff4');
Page.secondaryCategoryProp = defineProperty('018c354b2a4c420857e5');
Page.rankProp = defineProperty('018c354b4c2669879496');
Page.nameProp = defineProperty('018c354b650f315bd745');
Page.imageTagProp = defineProperty('018c354b9018ef186d6f');
Page.pathProp = defineProperty('018c354ba71a1c7a5020');
